<template>
    <div class="page exams-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <export-files v-if="loadedData" :files="loadedData.files" @loadMore="loadMore" @search="search" @reset="reset" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import ExportFiles from './ExportFiles';

export default {
    name: "",
    components: {
        ExportFiles
    },
    data(){
        return {
            loading: false,
            loadedData: null,

            get_url: '/export-files?p=1',
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                window.axios.get(this.get_url).then(response=>{
                    this.loadedData = response.data;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        this.$router.push('/not-found')
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
        loadMore(page){
            this.get_url = this.get_url.split('&page=')[0] + '&page=' + page; // remove page={value} if exists and add page={page}
            this.loadData();
        },
        search(query){
            this.resetUrl();
            this.get_url += '&query=' + query; // remove page={value} if exists and add page={page}
            this.loadData();
        },
        reset(){
            this.resetUrl();
            this.loadData();
        },
        resetUrl(){
            this.get_url = this.get_url.split('&query=')[0].split('&page=')[0];
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
.stats{
    margin: -8px;
    .col-lg-3, .col-lg-4{
        padding: 8px!important;
    }
}
</style>
